import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/home'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect:'/index',
    children:[
      {
        path: '/index',
        name: 'index',
        component: () => import('../views/index/index')
      },{
        path: '/intro',
        name: 'intro',
        component: () => import('../views/intro/index')
      },{
        path: '/product',
        name: 'product',
        component: () => import('../views/product/product')
      },{
        path: '/proDetails',
        name: 'proDetails',
        component: () => import('../views/product/proDetails')
      },{
        path: '/system',
        name: 'system',
        component: () => import('../views/system/system')
      },{
        path: '/sysDetails',
        name: 'sysDetails',
        component: () => import('../views/system/sysDetails')
      },{
        path: '/software',
        name: 'software',
        component: () => import('../views/software/software')
      },{
        path: '/company',
        name: 'company',
        component: () => import('../views/company/company')
      },{
        path: '/newDetails',
        name: 'newDetails',
        component: () => import('../views/company/newDetails')
      },{
        path: '/aboutUS',
        name: 'aboutUS',
        component: () => import('../views/aboutUS/aboutUS')
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
